import { AUTH_SERVICE_URL } from '@constants/externalRoutes';
import api from '../utils/api';

const refreshToken = async (): Promise<unknown> => {
  const response = await api(`${AUTH_SERVICE_URL}/refreshToken`, { method: 'POST', withCredentials: true });

  return response?.data as unknown;
};

const IspApi = {
  refreshToken,
};

export default IspApi;
